import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';

const SidebarGroup: React.FC<{ label: string; items: any[]; sessionId: string; onSelectSession: (id: string) => void; pinnedIds?: string[]; onTogglePin?: (id: string, e: React.MouseEvent) => void }> = ({ label, items, sessionId, onSelectSession, pinnedIds = [], onTogglePin }) => {
    if (items.length === 0) return null;
    return (
        <Box sx={{ mb: 2 }}>
            <Typography sx={{ px: 2, pt: 1, pb: 0.5, fontSize: '11px', fontWeight: 700, color: '#334155', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {label}
            </Typography>
            {items.map((s) => {
                const isActive = s.session_id === sessionId;
                const isPinned = pinnedIds.includes(s.session_id);
                return (
                    <Box key={s.session_id} onClick={() => onSelectSession(s.session_id)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 0.5,
                            mx: 1,
                            px: 1.5,
                            py: 1,
                            mb: 0.5,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            backgroundColor: isActive ? '#FFFFFF' : 'transparent',
                            border: isActive ? '1px solid #E2E8F0' : '1px solid transparent',
                            boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.04)' : 'none',
                            '&:hover': {
                                backgroundColor: isActive ? '#FFFFFF' : 'rgba(255,255,255,0.6)',
                                borderColor: isActive ? '#E2E8F0' : 'transparent',
                                '& .pin-icon': { opacity: 1 }
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
                            <Typography sx={{ fontSize: '13px', fontWeight: isActive ? 600 : 500, color: isActive ? '#0F172A' : '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {s.preview || 'New conversation'}
                            </Typography>
                        </Box>
                        {onTogglePin && (
                            <IconButton
                                size="small"
                                onClick={(e) => onTogglePin(s.session_id, e)}
                                className={isPinned ? '' : 'pin-icon'}
                                sx={{
                                    p: 0.5,
                                    opacity: isPinned ? 1 : 0,
                                    transition: 'opacity 0.2s',
                                    color: isPinned ? '#003771' : '#94A3B8',
                                    '&:hover': { color: '#003771', backgroundColor: 'rgba(0,55,113,0.05)' }
                                }}
                            >
                                {isPinned ? <PushPinIcon sx={{ fontSize: 15 }} /> : <PushPinOutlinedIcon sx={{ fontSize: 15 }} />}
                            </IconButton>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default SidebarGroup;
